import * as React from 'react';

import { ITaskCardProps } from './common';
import { TaskPill } from './TaskPill';

type TaskCardNotification = Pick<ITaskCardProps, 'notification' | 'status'>;

export const TaskCardNotification: React.FunctionComponent<TaskCardNotification> = ({ notification, status }) => {
  if (!!notification) {
    return (
      <TaskPill pillColor='alert'>{notification}</TaskPill>
    );
  } else if (status === 'review') {
    return (
      <TaskPill pillColor='primary'>Submitted</TaskPill>
    );
  } else if (status === 'complete') {
    return (
      <TaskPill pillColor='success'>Completed</TaskPill>
    );
  } else {
    return null;
  }
};
